<template>
    <!-- 添加或修改用户配置对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="650px" append-to-body>
        <el-form ref="form" :model="form" :rules="rules" label-width="140px" style="height: 500px;overflow: auto;">
            <el-row>
                <el-col :span="24" v-if="title == '任务详情'">
                    <el-form-item label="任务编码">
                        {{ form.tasknumber }}
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="指派人" prop="dealerid">
                        <el-select v-model="form.dealerid" clearable placeholder="指派人" style="width: 410px"
                            size="small" @change="dealChange" :disabled="logintype == 'DEALER'">
                            <el-option v-for="item in dealernameList" :key="item.id" :label="item.dealername"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="购买平台" prop="platform">
                        <el-select v-model="form.platform" clearable placeholder="购买平台" style="width: 410px"
                            size="small" :disabled="logintype == 'DEALER'" >
                            <el-option v-for="item in shopPlatform" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="店铺名称" prop="shopname">
                        <el-input v-model="form.shopname" clearable placeholder="店铺名称" style="width: 410px;"
                            size="small" :disabled="logintype == 'DEALER'"/>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="购买产品" prop="productname">
                        <el-input v-model="form.productname" clearable placeholder="购买产品" style="width: 410px;"
                            size="small" :disabled="logintype == 'DEALER'"/>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="规格" prop="specification">
                        <el-input v-model="form.specification" clearable placeholder="规格" style="width: 410px;"
                            size="small" :disabled="logintype == 'DEALER'"/>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="管控标准" prop="controlstandard">
                        <el-input v-model="form.controlstandard" clearable placeholder="管控标准" style="width: 410px;"
                            size="small" :disabled="logintype == 'DEALER'"/>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="购买链接" prop="productlink">
                        <el-input v-model="form.productlink" clearable placeholder="购买链接" style="width: 410px;"
                            size="small" :disabled="logintype == 'DEALER'"/>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <el-form-item label="要求购买完成日期" prop="completedate">
                        <el-date-picker v-model="form.completedate" value-format="yyyy-MM-dd" type="date"
                            style="width: 410px;" size="small" :disabled="logintype == 'DEALER'"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="购买要求" prop="purchaserequirement">
                        <el-input v-model="form.purchaserequirement" clearable placeholder="购买要求" style="width: 410px;"
                            size="small" :disabled="logintype == 'DEALER'"/>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="停止购买要求" prop="stopbuyingrequest">
                        <el-input v-model="form.stopbuyingrequest" clearable placeholder="停止购买要求" style="width: 410px;"
                            size="small" :disabled="logintype == 'DEALER'"/>
                    </el-form-item>
                </el-col>
                <el-col :span="24" v-if="title == '任务详情'">
                    <el-form-item label="创建时间">
                        {{ form.createtime | fullTime }}
                    </el-form-item>
                </el-col>
                <el-col :span="24" v-if="title == '任务详情'">
                    <el-form-item label="创建人">
                        {{ form.createuser }}
                    </el-form-item>
                </el-col>
                <el-col :span="24" v-if="title == '任务详情'">
                    <el-form-item label="更新时间" v-if="form.updatetime">
                        {{ form.updatetime | fullTime }}
                    </el-form-item>
                </el-col>
                <el-col :span="24" v-if="title == '任务详情'">
                    <el-form-item label="更新人" v-if="form.updateuser">
                        {{ form.updateuser }}
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm" v-if="logintype !== 'DEALER'">确 定</el-button>
            <el-button @click="cancel">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: "hcmIndexChild",
    components: {},
    data() {
        return {
            // 表单参数
            form: {},
            rules: {
                platform: [
                    { required: true, message: '请选择购买平台', trigger: 'blur' },
                ],
                shopname: [
                    { required: true, message: '请填写店铺名称', trigger: 'blur' },
                ],
                productlink: [
                    { required: true, message: '请填写购买链接', trigger: 'blur' },
                ],
                productname: [
                    { required: true, message: '请填写购买产品', trigger: 'blur' },
                ],
                completedate: [
                    { required: true, message: '请选择要求购买完成日期', trigger: 'blur' },
                ],
                specification: [
                    { required: true, message: '请输入规格', trigger: 'blur' },
                ],
                controlstandard: [
                    { required: true, message: '请输入管控标准', trigger: 'blur' },
                ],
                purchaserequirement: [
                    { required: true, message: '请输入购买要求', trigger: 'blur' },
                ],
                stopbuyingrequest: [
                    { required: true, message: '请输入停止购买要求', trigger: 'blur' },
                ]
            },
            open: false,
            title: '',
            logintype: '',
            dealernameList: [],
            shopPlatform: [{
                label: '淘宝',
                value: '淘宝'
            }, {
                label: '天猫',
                value: '天猫'
            }, {
                label: '京东',
                value: '京东'
            }, {
                label: '拼多多',
                value: '拼多多'
            }, {
                label: '抖音',
                value: '抖音'
            }, {
                label: '闲鱼',
                value: '闲鱼'
            }, {
                label: '快手',
                value: '快手'
            }, {
                label: '唯品会',
                value: '唯品会'
            }, {
                label: '微信小程序',
                value: '微信小程序'
            }],
        };
    },
    created() { },
    methods: {
        // 新增
        handleAdd(data) {
            this.logintype = JSON.parse(localStorage.getItem('userData')).logintype;
            if (data) {
                this.form = data;
                this.form.completedate = this.$options.filters.fullTime(this.form.completedate);
                this.title = "任务详情";
            } else {
                this.form = {};
                this.title = "任务录入";
            }
            
            this.getlistOfBmc();
        },
        // 新增下拉指派人
        getlistOfBmc() {
            fetch({
                url: "hcm/dealer/getlistOfBmc",
                method: "get",
                noFormat: true,
                responseType: "text"
            }).then((res) => {
                let result = JSON.parse(res)
                if (result.status == '10000') {
                    this.dealernameList = result.data
                    this.open = true;
                    // this.$refs['form'].resetFields();
                }
            })
        },
        // 获取指派人名字
        dealChange() {
            for (let a in this.dealernameList) {
                if (this.dealernameList[a].id == this.form.dealerid) {
                    this.form.dealername = this.dealernameList[a].dealername;
                }
            }
            console.log(this.form.dealername)
        },
        // 提交
        submitForm() {
            this.$refs["form"].validate((valid) => {
                if (valid) {
                    fetch({
                        url: "hcm/hcmOrdertaskbmc/saveOrderTask",
                        method: "post",
                        data: JSON.stringify(this.form),
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        noFormat: false,
                        responseType: "json"
                    }).then((res) => {
                        if (res.status === '10000') {
                            this.$message({
                                message: '操作成功！',
                                type: 'success'
                            })
                            this.open = false;
                            this.$emit('call-parent-method');
                        } else {
                            this.$message.error(res.message);
                        }
                    }).catch(err => {
                        this.$message.error('服务器出错');
                    });
                }
            });
        },
        // 取消
        cancel() {
            this.open = false;
        },
    }
};
</script>
<style lang="scss">
#buyingTask {
    .el-table th {
        background-color: #f3f7ff !important;
    }

    .el-table__empty-text {
        padding-top: 100px;
        background: url("../../../assets/img/other/nodata.svg") no-repeat;
        background-position: center 66px;
    }

    .el-dialog__header {
        padding: 20px 20px 10px;
        border-bottom: 1px solid #d9d9d9;
    }

    .el-table thead {
        color: #333333;
        font-weight: 500;
    }

    .el-button+.el-button {
        margin-left: 0px;
    }

    .bottom_page .el-pagination {
        text-align: right;
        margin-top: 0px;
        padding-bottom: 0px;
    }
}
</style>